import { useEffect, type ReactNode } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useAuth } from "./store";
import { Skeleton } from "../components/States";

/** Blocks /staff for anyone who is not a SaaS operator. */
export function RequireStaff({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const navigate = useNavigate();
  const staff = !!auth.me?.user.staff;
  useEffect(() => {
    if (auth.status === "authed" && !staff) {
      void navigate({ to: "/", replace: true });
    }
  }, [auth.status, staff, navigate]);
  if (auth.status !== "authed") return <Skeleton lines={4} />;
  if (!staff) return <Skeleton lines={3} />;
  return <>{children}</>;
}
